import template from '../lead.popup/lead.popup.html';
import { LeadPopupCtrl } from './lead.popup.controller';

leadPopupRoutesConfig.$inject = ['$stateProvider'];

export function leadPopupRoutesConfig($stateProvider) {
  $stateProvider
    .state('leadpopup', {
      url: '/leadpopup',
      template: '<ui-view/>',
    })
    .state('leadpopup.view', {
      url: '/view/:id',
      controller: LeadPopupCtrl,
      controllerAs: 'vm',
      template,
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
      },
    });
}
